const alt = (altText?: string | null) => {
  if (!altText) return 'PGSCOM';
  return altText;
};

export default alt;
